<template>
<el-container class="login-main">
  <el-aside class="left-side" :width="sideWidth"></el-aside>
  <el-container>      
      <!-- <div class="login"> 
      </div> -->      
      <el-image  ref="bgImg" :src="require('@images/logo_zju_new.png')" fit="fill"  @load="loadImgComplete" ></el-image>
      <div class="info" v-if="loadImg">
        <span class="title">欢迎登录实验教学中心课程管理系统</span>          
        <el-form :model="login_Form" ref="login_Form" :rules="rules" class="demo-ruleForm" @keyup.enter.native="login('login_Form')">
          <el-form-item prop="account">
            <el-input type="text" v-model="login_Form.account" class="login_item" placeholder="请输入学号/工号" clearable></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="login_Form.password" class="login_item" placeholder="请输入密码" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login_item" :loading="isLoading" @click="login('login_Form')">登录</el-button>
          </el-form-item>
           <el-link :underline="false" class="contact" type="primary">学生初始密码为身份证后6位，请登录后修改</el-link>
           <el-link :underline="false" class="contact" type="primary">有问题请联系 13116749532（朱老师）</el-link>
        </el-form>
      </div>
      <!-- <div class="footer">
        <span>有问题请联系 13116749532（朱老师）</span>
      </div>   -->

      <!--找回密码对话框-->
      <el-dialog title="找回密码" :visible.sync="findPasswordDialogVisible" width="35%" @close="resetFindPasswordDialog">
        <el-form :model="findPasswordForm" ref="findPasswordForm" :rules="rules">
          <el-form-item label="账号" :label-width="labelWidth" prop="account">
            <el-input v-model="findPasswordForm.account" placeholder="请输入账号" clearable></el-input>
          </el-form-item>
          <el-form-item label="身份证号" :label-width="labelWidth" prop="sid">
            <el-input v-model="findPasswordForm.sid" placeholder="请输入身份证号" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetFindPasswordDialog">取 消</el-button>
          <el-button type="primary" @click="findPassword('findPasswordForm')">确 定</el-button>
        </div>
      </el-dialog>       
  </el-container>
  <el-aside class="right-side" :width="sideWidth"></el-aside>

</el-container>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      isLoading: false,
      findPasswordForm: {
        account: '',
        sid: ''
      },
      findPasswordDialogVisible: false,
      labelWidth: '100px',
      rules: {
        //  {pattern:/\b\d{12}\b/,message:'请输入12位数字的学号',trigger:'blur'}
        //  {pattern:/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message:'请输入正确的身份证号码',trigger:'blur'}

        account: [{ required: true, message: '请输入账号', trigger: 'blur' },
          // {pattern:/\b\d{10}\b/,message:'请输入10位数字的学号',trigger:'blur'}
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' },
        { min: 2, max: 20, message: '长度在 5到 20个字符', trigger: 'blur' }],
        sid: [{ required: true, message: '请输入身份证号', trigger: 'blur' },
        { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号码', trigger: 'blur' }
        ]
      },
      login_Form: {
        account: '',
        password: ''
      },
      loadImg:false, 
      sideWidth:'0px'    
    };
  },
  computed: {
    // sideWidth() {   
    //   let toubleWidth = (document.documentElement.clientWidth-this.$refs.bgImg.offsetWidth)   
    //   return ((toubleWidth<0)?0:parseInt(toubleWidth/2)+10)+'px'
    // }
  },  

  mounted() {

  },  
  methods: {
    loadImgComplete(){
      this.loadImg = true
      let imageWidth = this.$refs.bgImg.$el.offsetWidth
      this.$nextTick(() => {
        let toubleWidth = (document.documentElement.clientWidth-imageWidth) 
        this.sideWidth = ((toubleWidth<0)?0:parseInt(toubleWidth/2)+10)+'px'
      })     
    },
    findPassword(formName) {
      //找回密码
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //校验通过
          let that = this;
          let formData = new FormData();
          formData.append('account', this.findPasswordForm.account);
          formData.append('sid', this.findPasswordForm.sid);
          this.$axios({
            method: 'post',
            data: formData,
            url: this.apiUrl.findPassword
          }).then(response => {
            if (response.data.status == 200) {
              this.$notify({
                title: '找回密码',
                message: response.data.data.detailMessage,
                type: 'success'
              });
              that.findPasswordDialogVisible = false;
            } else {
              that.common.errorReturn(that, response.data.data.detailMessage);
            }
          }).catch(error => {
            console.log('---error---', error);
          })
        }
      })

    },
    resetFindPasswordDialog() {
      this.$refs['findPasswordForm'].resetFields();
      this.findPasswordDialogVisible = false;
    },
    login(formName) {
      //登录
      // let formData = new FormData();
      // formData.append("account", this.login_Form.account);
      // formData.append('password', this.login_Form.password);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //校验通过
          this.isLoading = true;
          let that = this;
          // this.$axios({
          //     method:'post',
          //     url:this.apiUrl.login,
          //     data:formData
          // })
          this.$store.dispatch('Login',  this.login_Form).then(response => {

            if (response.data.status == 200) {

              //登录成功
              // that.$message({
              //   message: '登录成功',
              //   type: 'success '
              // });
              // localStorage.setItem('user', JSON.stringify(response.data.data.data));
              localStorage.setItem('account', this.login_Form.account);
              // that.$router.push("/index");
              this.$router.push({path: '/'});
            } else {
              that.common.errorReturn(that, response.data.data.detailMessage);
              //that.isLoading=false;
            }
            that.isLoading = false;
          }).catch(err => {
            console.log('----err---', err);
            that.isLoading = false;
          })
        }
      });
    }
  }
}
</script>

<style scoped>
.login-main{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
}

.login {
  /* width: 100%; */
  height: 100%; 
  position: absolute;
  left: 0;
  top: 0;
  /* right: 0;
  bottom: 0; */
  /* min-width: 1000px;  
  min-height: 600px;   */
  background-image: url("~@images/logo_zju_new.png");
  text-align: center;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.left-side{ 
  background: -webkit-gradient(linear, 100% 50%, 0 50%, from(#d2d5dc), to(#ffffff))
} 
.right-side{   
  background: -webkit-gradient(linear, 0 50%, 100% 50%, from(#d2d5dc), to(#ffffff));
}
.info {
  padding: 20px;
  background-color: #003f88;
  position: absolute;
  left: 35%;
  top: 30%;
  border-radius: 10px;
}
.contact{
  font-size: 16px;
  color: #c1c9d1;  
  justify-content: flex-start;
}
.a-left{justify-content: flex-start}
.footer{ 
  background-color: #003f88; 
  position: absolute;
  right: 45%;
  bottom: 20px;
  font-size: 16px;
  color: #fff;  
  /* border-radius: 15px; */
}
.demo-ruleForm {
  display: flex;
  flex-direction: column;
  padding: 20px 30px 20px 30px;
}
.login_item {
  width: 100%;
  height: 45px;
  font-size: 18px;
}
.title {
  font-family: "Hiragino Sans GB";
  font-size: 24px;
  color: #fff;
  padding-left: 10px;
}
</style>